import { Pipe } from '@angular/core';
import { isObject } from '../utils/utils';
var KeysPipe = (function () {
    function KeysPipe() {
    }
    KeysPipe.prototype.transform = function (input) {
        if (!isObject(input)) {
            return input;
        }
        return Object.keys(input);
    };
    return KeysPipe;
}());
export { KeysPipe };
KeysPipe.decorators = [
    { type: Pipe, args: [{ name: 'keys' },] },
];
/** @nocollapse */
KeysPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=keys.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/object/keys.pipe.js
// module id = 271
// module chunks = 103